import {Kink} from "../Common/Kink";

export class Match {
  public similarity: number = 0;
  public complementarity: number = 0;
  public kink: Kink;
  public comparativeKinkList: Kink[];

  constructor(kink: Kink, kinkListCompare: Kink[]) {
    this.kink = kink;
    this.comparativeKinkList = kinkListCompare;
    const sameKink = kinkListCompare.find(k => k.label === kink.label);
    const sameValue = sameKink ? sameKink.value : 0;
    this.similarity = 100 - Math.abs(kink.value - sameValue);

    const oppositeLabel = Match.getOpposite(kink.label);
    const oppositeKink = oppositeLabel ? kinkListCompare.find(k => k.label === oppositeLabel) : undefined;
    const oppositeValue = oppositeKink ? oppositeKink.value : 0;
    this.complementarity = 100 - Math.abs(kink.value - oppositeValue);
  }

  public static getOpposite(kinkLabel: string): string {
    switch (kinkLabel) {
      case 'Fréquence':
        return 'Fréquence';
      case 'Expérimentaliste':
        return 'Expérimentaliste';
      case 'Dominant(e)':
        return 'Soumis(e)';
      case 'Attacheur':
        return 'Attaché(e)';
      case 'Daddy/Mommy':
        return 'Boy/Girl';
      case 'Switch':
        return 'Switch';
      case 'Primal Predator':
        return 'Primal Prey (Proie)';
      case 'Maître/Maîtresse':
        return 'Esclave';
      case 'Brat Tamer':
        return 'Brat (Sale gosse)';
      case 'Attaché(e)':
        return 'Attacheur';
      case 'Sadique':
        return 'Masochiste';
      case 'Primal Prey (Proie)':
        return 'Primal Predator';
      case 'Fétichiste':
        return 'Fétichiste';
      case 'Soumis(e)':
        return 'Dominant(e)';
      case 'Masochiste':
        return 'Sadique';
      case 'Pet (Animal de compagnie)':
        return 'Handler (Petplay)';
      case 'Handler (Petplay)':
        return 'Pet (Animal de compagnie)';
      case 'Humilié(e)':
        return 'Humiliant(e)';
      case 'Brat (Sale gosse)':
        return 'Brat Tamer';
      case 'Esclave':
        return 'Maître/Maîtresse';
      case 'Boy/Girl':
        return 'Daddy/Mommy';
      case 'Humiliant(e)':
        return 'Humilié(e)';
      case 'Poly':
        return 'Poly';
      default:
        return '';
    }
  }
}
